.background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,.1);
    z-index: 10;
    padding: 16px;
    height: 100vh;
}

.popup {
    padding: var(--space-6);
    border: 1px solid var(--color-border-medium);
    box-shadow: var(--shadow-lg);
    border-radius: var(--radius-sm);
    background-color: white;
    position: relative;
    max-width: 600px;
    max-height: 90vh;
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 4px;
}

.popupHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1em;
    flex-shrink: 0;
    margin-bottom: 0.75em;
}

.popupBody {
    overflow-y: auto;
    flex: 1;
    min-height: 0;
}

.closeButton {
    background-color: transparent;
    border: none;
    padding: 4px;
    /* Pull the padded hit area out so the icon itself lines up with the
       content's right edge */
    margin: -4px -4px -4px 0;
    flex-shrink: 0;
}

.closeButton:hover:enabled {
    background-color: transparent;
}

.closeIcon {
    display: block;
    width: 16px;
    height: 16px;
}

.confirmButton {
    background-color: var(--color-button-regular-bg);
    color: var(--color-button-regular-text);
}

.confirmButton:hover:enabled {
    background-color: var(--color-button-regular-bg-hover);
    color: var(--color-button-regular-text-hover);
}

.confirmDangerButton {
    background-color: var(--color-red-50);
    color: var(--color-red-600);
    border: 1px solid var(--color-red-200);
}

.confirmDangerButton:hover:enabled {
    color: var(--color-red-700);
    background-color: var(--color-red-200);
    border: 1px solid var(--color-red-200);
}

.confirmDangerButton:disabled {
    background-color: var(--color-gray-100);
    color: var(--color-gray-400);
    border: 1px solid var(--color-gray-300);
    cursor: not-allowed;
}

.buttonWrapper {
    border-top: 1px solid var(--color-border-light);
    margin-top: 12px;
    padding-top: 16px;
    display: flex;
    gap: 1em;
}

.buttonWrapper > button {
    flex-grow: 1;
    padding: 16px 0px;
}

.cancelButton {
    background-color: transparent;
    color: black;
}

.cancelButton:hover {
    background-color: var(--color-button-muted-bg-hover);
    color: var(--color-button-muted-text-hover);
}

.headerText {
    margin: 0;
    font-weight: bold;
    font-size: large;
    line-height: 1.5;
}
